import React from 'react'
import GptSearchBar from './GptSearchBar'
import GptMovieSuggestions from './GptMovieSuggestions'
import { NeflixBG } from '../utils/constants'

const GptSearch = () => {
  return (

    <>
    <div className='fixed -z-10'>
      <img className='h-screen w-screen object-cover sm:object-none ' src={NeflixBG} />
    </div>
    <div>
      <GptSearchBar />
      <GptMovieSuggestions />
    </div>
    </>
  )
}

export default GptSearch